import { Facet } from "./facets.generated.js";
export const facets = Object.keys(Facet);
